import { render, staticRenderFns } from "./PeopleView.vue?vue&type=template&id=5e47945c&scoped=true&"
import script from "./PeopleView.vue?vue&type=script&lang=js&"
export * from "./PeopleView.vue?vue&type=script&lang=js&"
import style0 from "./PeopleView.vue?vue&type=style&index=0&id=5e47945c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e47945c",
  null
  
)

export default component.exports